import { useCallback, useEffect, useState, useSyncExternalStore } from 'react';
import { assessFit, deleteCachedModel, getHardwareProfile, getRuns, listCachedModels, registry as defaultRegistry, subscribeRuns, } from '@front-brain/core';
/** All models currently loaded in memory (any runtime). */
export function useLoadedModels(reg = defaultRegistry) {
    return useSyncExternalStore(reg.subscribe, reg.list);
}
export function useLoadedModel(key, reg = defaultRegistry) {
    return useLoadedModels(reg).find((m) => m.key === key);
}
export function useHardware() {
    const [hw, setHw] = useState(null);
    useEffect(() => {
        getHardwareProfile().then(setHw);
    }, []);
    return hw;
}
/** Advisory fit of a model on this device (null until hardware is detected). */
export function useFit(req, device, dtype) {
    const hw = useHardware();
    return hw && req ? assessFit(req, hw, device, dtype) : null;
}
export function useRuns() {
    return useSyncExternalStore(subscribeRuns, getRuns);
}
/** Models downloaded to Cache Storage, with refresh/delete. */
export function useCachedModels() {
    const [models, setModels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const refresh = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            setModels(await listCachedModels());
        }
        catch (e) {
            // e.g. SecurityError when storage is blocked
            setError(e.message);
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        refresh();
    }, [refresh]);
    const remove = useCallback(async (m) => {
        await deleteCachedModel(m);
        await refresh();
    }, [refresh]);
    return { models, loading, error, refresh, remove };
}
//# sourceMappingURL=hooks.js.map